import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import { SelectTerminalDrawerService } from '@/views/dashboard/_components/select-terminal-drawer/select-terminal-drawer.service'
import type { ClientItem } from '@/views/dashboard/_type/client-item'
import {
  PolicyCommonService,
} from '@/views/dashboard/policy/policy-common.service'
import { computerInfoCols } from '../../data-safe/ransomware-protection/types/ransomware-incident'
import { formLabelStyle } from '@/components/cmForm/globalOpt'


export default /*#__PURE__*/_defineComponent({
  __name: 'used-policy-terminals',
  props: {
    modelValue: { type: Boolean },
    device_ids: { default: [] },
    name: { default: '' },
    settingsType: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

/** CmTable 要求 v-model，抽屉内无筛选，仅占位与接口一致 */
const tableForm = reactive<Record<string, unknown>>({})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    columns: [...computerInfoCols(false,false,t)
    ],
    bodyStyle: 'padding: 10px 16px',
    rowKey: 'device_id',
    hiddenPageTool: true,
    disableScrollLoad: true,
    showActionBar: false,
    height: '100%',
  }
})

const props = __props

const emit = __emit

const injector = useReflectiveInjector([PolicyCommonService, SelectTerminalDrawerService])
const selectTerminalService = injector.get(SelectTerminalDrawerService)

const loading = ref(false)
const tableRows = ref<ClientItem[]>([])

/** 与 policy-bind-scope 一致：按 device_ids 拉终端明细用于表格展示 */
function hydrateTerminalsFromDeviceIds() {
  loading.value = true
  selectTerminalService
    .getTerminalList({
      device_ids: props.device_ids,
      group_id: -1,
      page: 1,
      limit: Math.max(props.device_ids.length, 20),
    })
    .then((res) => {
      tableRows.value = res.terminal_list || []
    })
    .catch(() => {
      tableRows.value = props.device_ids.map((id) => ({
        device_id: id,
        computer_name: ''
      } as ClientItem))
    })
    .finally(() => {
      loading.value = false
    })
}

function handleClose() {
  emit('update:modelValue', false)
}

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      hydrateTerminalsFromDeviceIds()
    } else {
      tableRows.value = []
    }
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "used-policy-terminals-wrap",
    title: `[${_ctx.name}] ${_ctx.$t('policyManage.applyTerminalsDrawerTitle')}`,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "60%",
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(CmTable, {
        modelValue: tableForm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tableForm) = $event)),
        class: "used-policy-terminals__terminal-table",
        style: {"flex":"1"},
        data: tableRows.value,
        "table-opt": tableOpt.value,
        "first-loading": false
      }, null, 8, ["modelValue", "data", "table-opt"]), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})